// extracted by mini-css-extract-plugin
export default {"main":"Navbar_main__CylcJ","link":"Navbar_link__Xlpy8"};